/* corex-textil-editor-pointer.js · Puntero del personalizador de camisetas: mover (con tope: ed.clampMove), escalar,
   girar y pellizcar elementos sobre la prenda; teclado; reordenar capas en la lista. Las impresiones no se arrastran: se forman solas
   con los elementos cercanos. attach(ed) recibe los accesos al estado del editor (ver corex-textil-editor.js). */
(function () {
  'use strict';

  var G = window.CorexTextilGeo, IO = window.CorexTextilIO, D = window.CorexTextilDraw;

  function attach(ed) {
    var pointers = {}, drag = null;
  /* ---------- puntero en el editor ---------- */
  function pointerImage(e) {
    var r = ed.canvas.getBoundingClientRect(), f = ed.metrics().frame;
    return { x: f.view.x + (e.clientX - r.left) / ed.metrics().s, y: f.view.y + (e.clientY - r.top) / ed.metrics().s };
  }
  function toUV(e) { var p = pointerImage(e); return ed.metrics().frame.inv(p.x, p.y); }
  function local(it, uv) { return { x: uv.u - it.area.cu, y: uv.v - it.cv }; }
  function hitHandle(l, p, tol) {
    var rh = D.rotHandle(l, ed.metrics().cmPerPx);
    if (Math.hypot(p.x - rh.x, p.y - rh.y) <= tol * 1.3) return 'rotate';
    return G.layerCorners(l).some(function (c) { return Math.hypot(p.x - c.x, p.y - c.y) <= tol; }) ? 'scale' : null;
  }
  function hitLayerIn(it, uv) {
    var p = local(it, uv), ls = it.print.layers;
    for (var i = ls.length - 1; i >= 0; i--) {
      var l = ls[i], s = G.layerSize(l), lp = G.toLocal(l, p);
      if (!l.hidden && Math.abs(lp.x) <= s.w / 2 && Math.abs(lp.y) <= s.h / 2) return l;
    }
    return null;
  }
  /* Orden de prueba: la impresión activa primero, luego las demás de arriba abajo. */
  function itemsForHit() {
    var active = ed.activePrint(), list = ed.metrics().items.slice().reverse();
    return list.filter(function (it) { return active && it.print.id === active.id; }).concat(list.filter(function (it) { return !active || it.print.id !== active.id; }));
  }
  function pinchInfo() {
    var pts = Object.keys(pointers).map(function (k) { return pointers[k]; });
    return { dist: Math.hypot(pts[1].x - pts[0].x, pts[1].y - pts[0].y), angle: Math.atan2(pts[1].y - pts[0].y, pts[1].x - pts[0].x) };
  }
  function onPointerDown(e) {
    if (!ed.metrics() || ed.lockReason()) return;
    var uv = toUV(e), ai = ed.itemOf(ed.activePrint()), sel = ed.selected();
    pointers[e.pointerId] = ai ? local(ai, uv) : { x: uv.u, y: uv.v };
    ed.canvas.setPointerCapture(e.pointerId);
    ed.canvas.focus({ preventScroll: true });
    if (Object.keys(pointers).length === 2 && sel) {
      var pi = pinchInfo();
      drag = { mode: 'pinch', id: sel.id, dist0: pi.dist, angle0: pi.angle, base: Object.assign({}, sel), rot0: sel.rotation || 0 };
      return;
    }
    var tol = (e.pointerType === 'touch' ? 2.2 : 1.2) * D.HANDLE_PX * ed.metrics().cmPerPx;
    var p = ai && local(ai, uv), handle = sel && !sel.hidden ? hitHandle(sel, p, tol) : null;
    drag = null;
    if (handle === 'rotate') drag = { mode: 'rotate', id: sel.id, a0: Math.atan2(p.y - sel.y, p.x - sel.x), rot0: sel.rotation || 0 };
    else if (handle === 'scale') {
      /* el gesto se mide desde el ancla del escalado (borde superior o inferior), fija durante el arrastre */
      var an = ed.scaleAnchor(sel);
      drag = { mode: 'scale', id: sel.id, an: an, d0: Math.hypot(p.x - an.x, p.y - an.y) || 1, base: Object.assign({}, sel) };
    }
    else {
      var hit = null;
      itemsForHit().some(function (it) { var l = hitLayerIn(it, uv); if (l) hit = { it: it, l: l }; return !!l; });
      if (hit && ed.isMulti(e)) {
        /* Mayús/Ctrl/Cmd + clic: añade o quita la capa de la selección (sin arrastrar) */
        ed.toggleSel(hit.it.print.id, hit.l.id);
        drag = null;
        return;
      }
      if (hit) {
        var lp = local(hit.it, uv);
        if (hit.it.print.id !== ed.state().printId || hit.l.id !== ed.state().sel) ed.selectOnly(hit.it.print.id, hit.l.id);
        drag = { mode: 'move', id: hit.l.id, dx: lp.x - hit.l.x, dy: lp.y - hit.l.y };
      } else if (ed.state().sel) ed.setState({ sel: null, selIds: [] });
    }
    if (drag) { ed.canvas.classList.add('is-dragging'); ed.onDrag(true); e.preventDefault(); }
  }
  function onPointerMove(e) {
    if (!(e.pointerId in pointers) || !ed.metrics() || !drag) return;
    var uv = toUV(e);
    var ai = ed.itemOf(ed.activePrint()), l = ed.selected();
    if (!ai || !l) return;
    var lp = local(ai, uv);
    pointers[e.pointerId] = lp;
    if (drag.mode === 'move') ed.patchLayerLive(l.id, ed.clampMove(l, { x: lp.x - drag.dx, y: lp.y - drag.dy }));
    else if (drag.mode === 'scale') ed.patchLayerLive(l.id, ed.scaleFrom(drag.base, Math.hypot(lp.x - drag.an.x, lp.y - drag.an.y) / drag.d0));
    else if (drag.mode === 'rotate') ed.patchLayerLive(l.id, ed.rotatePatch(l, IO.normalizeDeg(drag.rot0 + (Math.atan2(lp.y - l.y, lp.x - l.x) - drag.a0) * 180 / Math.PI)));
    else if (drag.mode === 'pinch' && Object.keys(pointers).length === 2) {
      var pi = pinchInfo();
      var sp = ed.scaleFrom(drag.base, pi.dist / (drag.dist0 || 1));
      var turned = Object.assign({}, l, sp);
      ed.patchLayerLive(l.id, Object.assign(sp, ed.rotatePatch(turned, IO.normalizeDeg(drag.rot0 + (pi.angle - drag.angle0) * 180 / Math.PI))));
    }
  }
  function onPointerUp(e) {
    delete pointers[e.pointerId];
    var rest = Object.keys(pointers);
    if (drag && drag.mode === 'pinch' && rest.length === 1) {
      var l = ed.selected(), p = pointers[rest[0]];
      drag = l ? { mode: 'move', id: l.id, dx: p.x - l.x, dy: p.y - l.y } : null;
      return;
    }
    if (!rest.length) {
      var was = !!drag;
      drag = null;
      ed.canvas.classList.remove('is-dragging');
      if (was) { ed.onDrag(false); ed.update(); }
    }
  }
  function onKey(e) {
    if (ed.lockReason()) return;
    var l = ed.selected(), step = e.shiftKey ? 2 : 0.5;
    var moves = { ArrowLeft: [-step, 0], ArrowRight: [step, 0], ArrowUp: [0, -step], ArrowDown: [0, step] };
    if (moves[e.key] && l) {
      e.preventDefault();
      ed.patchLayer(l.id, ed.clampMove(l, { x: l.x + moves[e.key][0], y: l.y + moves[e.key][1] }));
    } else if ((e.key === 'Delete' || e.key === 'Backspace') && l) {
      e.preventDefault();
      ed.removeLayer(l.id);
    }
  }

  /* Reordenar capas arrastrando ⋮⋮ (puntero, también táctil) o con flechas. */
  var listDrag = null;
  function onGripDown(e) {
    var grip = e.target.closest('[data-cte-grip]');
    if (!grip) return;
    var li = grip.closest('.cte-layer');
    grip.setPointerCapture(e.pointerId);
    listDrag = { id: li.dataset.id, li: li, y0: e.clientY, pointerId: e.pointerId };
    li.classList.add('is-dragging');
    e.preventDefault();
  }
  function onGripMove(e) {
    if (listDrag && e.pointerId === listDrag.pointerId) listDrag.li.style.transform = 'translateY(' + (e.clientY - listDrag.y0) + 'px)';
  }
  function onGripUp(e) {
    if (!listDrag || e.pointerId !== listDrag.pointerId) return;
    var others = ed.qa('.cte-layer').filter(function (li) { return li !== listDrag.li; });
    var idx = others.filter(function (li) { var r = li.getBoundingClientRect(); return e.clientY > r.top + r.height / 2; }).length;
    var id = listDrag.id;
    listDrag.li.style.transform = '';
    listDrag.li.classList.remove('is-dragging');
    listDrag = null;
    ed.resetList();
    ed.moveLayerTo(id, idx);
  }


    var list = ed.root.querySelector('[data-cte-layers]');
    list.addEventListener('pointerdown', onGripDown);
    list.addEventListener('pointermove', onGripMove);
    list.addEventListener('pointerup', onGripUp);
    list.addEventListener('pointercancel', onGripUp);
    ed.canvas.addEventListener('pointerdown', onPointerDown);
    ed.canvas.addEventListener('pointermove', onPointerMove);
    ed.canvas.addEventListener('pointerup', onPointerUp);
    ed.canvas.addEventListener('pointercancel', onPointerUp);
    ed.canvas.addEventListener('keydown', onKey);
  }

  window.CorexTextilPointer = { attach: attach };
})();
